import SpriteSymbol from "../../../../dev-d21-front/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../dev-d21-front/node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "reset",
  "use": "reset-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"reset\"><path d=\"M576 64c-249.6 0-448 198.4-448 448H0l160 192 160-192H192c0-211.2 172.8-384 384-384s384 172.8 384 384-172.8 384-384 384c-19.2 0-32 12.8-32 32s12.8 32 32 32c249.6 0 448-198.4 448-448S825.6 64 576 64\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol